import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M12 7.27l4.28 10.43-3.47-1.53-.81-.36-.81.36-3.47 1.53L12 7.27M12 2L4.5 20.29l.71.71L12 18l6.79 3 .71-.71L12 2z"
}), 'NavigationOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/NavigationOutlined.js
// module id = 5002
// module chunks = 2